import React from 'react';

class EmptyPlayer extends React.Component {
  render() {
    const RowTag = this.props.inPairGroup ? 'div' : 'li';

    return(
        <RowTag className="game__list-user game__list-user--empty-pair">
            <div className="game__list-user-photo">
                <img className="img-responsive game__list-pair-photo"
                     src="https://vk.com/images/deactivated_50.png?ava=1"
                     alt="Пока без пары "
                />
            </div>
            <div className="game__list-user-name">
                <span>Пока без пары</span>
            </div>
        </RowTag>
    );
  }
}

export default EmptyPlayer;
